import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class GlobalHttpInterceptor implements HttpInterceptor {
    constructor(private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            setHeaders: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
        });

        return next.handle(request).pipe(
            catchError(response => {
                if (response?.status === 403) {
                    this.router.navigate(['unauthorized']);
                    return throwError(response);
                }

                return throwError(response);
            })
        );
    }
}
